import * as React from 'react';

import { EPosition } from '../../../filters/components/filters/types';

const DISABLE_BY_SCROLL_TIMEOUT = 200;

export interface IParameters {
  filtersSectionPosition: EPosition;
}

/** Копипаста аналогичного хука из FiltersContainer, но без state, поскольку стейт лежит внутри микрофронта */
export function useTooltipDisabled({ filtersSectionPosition }: IParameters): boolean {
  const [isTooltipDisabledByPosition, setIsTooltipDisabledByPosition] = React.useState<boolean>(false);
  const [isTooltipDisabledByScroll, setIsTooltipDisabledByScroll] = React.useState(false);

  React.useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const handleScroll = () => {
      setIsTooltipDisabledByScroll(true);
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        clearTimeout(timeoutId);
        setIsTooltipDisabledByScroll(false);
      }, DISABLE_BY_SCROLL_TIMEOUT);
    };

    document.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  React.useEffect(() => {
    setIsTooltipDisabledByPosition(filtersSectionPosition === EPosition.FixedHidden);
  }, [filtersSectionPosition]);

  return isTooltipDisabledByPosition || isTooltipDisabledByScroll;
}
